import { Typography } from '@mui/material'
import { useRecordContext } from 'react-admin'
import { PromotionTitleProps } from './type'

export const PromotionTitle: React.FC<PromotionTitleProps> = ({ source, ...props }) => {
  const record = useRecordContext()
  return (
    <Typography variant='h3' {...props}>
      {record[source]}
    </Typography>
  )
}
